export class FormOnSubmit {

    /**
     * Not used anymore, keeping if they want to select stock order in the futrue
     *
     * @param form
     * @param data
     * @returns {*}
     */
    static processStockOrder (form, data){
        $('tr:has(input[type="checkbox"]:not(:checked)) input').each( function () {
            data.delete($(this).attr('name'))
        })

        return data;
    }
}
